module.exports = "<zmat-lgrid-table \n    [data]=\"data\"    \n    [schema]=\"gridSchema\" \n    [facade]=\"facade\" >\n</zmat-lgrid-table>"